import curry from "lodash/fp/curry";
const groupConsecutiveWith = curry(function groupConsecutiveWith2(isEqual, array) {
  return array.reduce((groups, element) => {
    let lastGroup = groups.at(-1);
    if (!lastGroup || !isEqual(lastGroup.at(-1), element)) {
      lastGroup = [];
      groups.push(lastGroup);
    }
    lastGroup.push(element);
    return groups;
  }, []);
});
export { groupConsecutiveWith as default };